<template>
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M51.7004 5.39088C51.8534 5.24153 52.0891 5.20112 52.2544 5.33677C52.6006 5.62103 52.9375 6.12297 52.9375 6.9209V52.0068C52.9375 56.7012 49.132 60.5068 44.4375 60.5068H14.875V58.8506H13.0938V6.51575C13.1957 5.88134 13.5299 5.48295 13.8457 5.26055C14.0072 5.14676 14.2214 5.18891 14.3656 5.32396L16.2307 7.07001C16.5431 7.36243 17.0302 7.3573 17.3363 7.05841L19.4207 5.02325C19.5751 4.8725 19.7823 4.78809 19.998 4.78809C20.2079 4.78809 20.4098 4.86786 20.563 5.01123L22.762 7.07001C23.0743 7.36243 23.5614 7.3573 23.8676 7.05841L25.9519 5.02325C26.1063 4.8725 26.3136 4.78809 26.5293 4.78809C26.7391 4.78809 26.941 4.86786 27.0942 5.01123L29.2932 7.07001C29.6056 7.36243 30.0927 7.3573 30.3988 7.05841L32.4832 5.02325C32.6376 4.8725 32.8448 4.78809 33.0605 4.78809C33.2704 4.78809 33.4723 4.86786 33.6255 5.01123L35.8245 7.07001C36.1368 7.36243 36.6239 7.3573 36.9301 7.05841L39.0144 5.02325C39.1688 4.8725 39.3761 4.78809 39.5918 4.78809C39.8016 4.78809 40.0035 4.86786 40.1567 5.01123L42.3557 7.07001C42.6681 7.36243 43.1552 7.3573 43.4613 7.05841L45.5457 5.02325C45.7001 4.8725 45.9073 4.78809 46.123 4.78809C46.3329 4.78809 46.5348 4.86786 46.688 5.01123L48.887 7.07001C49.1993 7.36243 49.6864 7.3573 49.9926 7.05841L51.7004 5.39088Z"
      fill="url(#paint0_linear_9837_4132)"
    />
    <path
      d="M51.7004 5.39088C51.8534 5.24153 52.0891 5.20112 52.2544 5.33677C52.6006 5.62103 52.9375 6.12297 52.9375 6.9209V52.0068C52.9375 56.7012 49.132 60.5068 44.4375 60.5068H14.875V58.8506H13.0938V6.51575C13.1957 5.88134 13.5299 5.48295 13.8457 5.26055C14.0072 5.14676 14.2214 5.18891 14.3656 5.32396L16.2307 7.07001C16.5431 7.36243 17.0302 7.3573 17.3363 7.05841L19.4207 5.02325C19.5751 4.8725 19.7823 4.78809 19.998 4.78809C20.2079 4.78809 20.4098 4.86786 20.563 5.01123L22.762 7.07001C23.0743 7.36243 23.5614 7.3573 23.8676 7.05841L25.9519 5.02325C26.1063 4.8725 26.3136 4.78809 26.5293 4.78809C26.7391 4.78809 26.941 4.86786 27.0942 5.01123L29.2932 7.07001C29.6056 7.36243 30.0927 7.3573 30.3988 7.05841L32.4832 5.02325C32.6376 4.8725 32.8448 4.78809 33.0605 4.78809C33.2704 4.78809 33.4723 4.86786 33.6255 5.01123L35.8245 7.07001C36.1368 7.36243 36.6239 7.3573 36.9301 7.05841L39.0144 5.02325C39.1688 4.8725 39.3761 4.78809 39.5918 4.78809C39.8016 4.78809 40.0035 4.86786 40.1567 5.01123L42.3557 7.07001C42.6681 7.36243 43.1552 7.3573 43.4613 7.05841L45.5457 5.02325C45.7001 4.8725 45.9073 4.78809 46.123 4.78809C46.3329 4.78809 46.5348 4.86786 46.688 5.01123L48.887 7.07001C49.1993 7.36243 49.6864 7.3573 49.9926 7.05841L51.7004 5.39088Z"
      fill="url(#paint1_radial_9837_4132)"
    />
    <path
      d="M51.7004 5.39088C51.8534 5.24153 52.0891 5.20112 52.2544 5.33677C52.6006 5.62103 52.9375 6.12297 52.9375 6.9209V52.0068C52.9375 56.7012 49.132 60.5068 44.4375 60.5068H14.875V58.8506H13.0938V6.51575C13.1957 5.88134 13.5299 5.48295 13.8457 5.26055C14.0072 5.14676 14.2214 5.18891 14.3656 5.32396L16.2307 7.07001C16.5431 7.36243 17.0302 7.3573 17.3363 7.05841L19.4207 5.02325C19.5751 4.8725 19.7823 4.78809 19.998 4.78809C20.2079 4.78809 20.4098 4.86786 20.563 5.01123L22.762 7.07001C23.0743 7.36243 23.5614 7.3573 23.8676 7.05841L25.9519 5.02325C26.1063 4.8725 26.3136 4.78809 26.5293 4.78809C26.7391 4.78809 26.941 4.86786 27.0942 5.01123L29.2932 7.07001C29.6056 7.36243 30.0927 7.3573 30.3988 7.05841L32.4832 5.02325C32.6376 4.8725 32.8448 4.78809 33.0605 4.78809C33.2704 4.78809 33.4723 4.86786 33.6255 5.01123L35.8245 7.07001C36.1368 7.36243 36.6239 7.3573 36.9301 7.05841L39.0144 5.02325C39.1688 4.8725 39.3761 4.78809 39.5918 4.78809C39.8016 4.78809 40.0035 4.86786 40.1567 5.01123L42.3557 7.07001C42.6681 7.36243 43.1552 7.3573 43.4613 7.05841L45.5457 5.02325C45.7001 4.8725 45.9073 4.78809 46.123 4.78809C46.3329 4.78809 46.5348 4.86786 46.688 5.01123L48.887 7.07001C49.1993 7.36243 49.6864 7.3573 49.9926 7.05841L51.7004 5.39088Z"
      fill="url(#paint2_linear_9837_4132)"
    />
    <path
      d="M51.7004 5.39088C51.8534 5.24153 52.0891 5.20112 52.2544 5.33677C52.6006 5.62103 52.9375 6.12297 52.9375 6.9209V52.0068C52.9375 56.7012 49.132 60.5068 44.4375 60.5068H14.875V58.8506H13.0938V6.51575C13.1957 5.88134 13.5299 5.48295 13.8457 5.26055C14.0072 5.14676 14.2214 5.18891 14.3656 5.32396L16.2307 7.07001C16.5431 7.36243 17.0302 7.3573 17.3363 7.05841L19.4207 5.02325C19.5751 4.8725 19.7823 4.78809 19.998 4.78809C20.2079 4.78809 20.4098 4.86786 20.563 5.01123L22.762 7.07001C23.0743 7.36243 23.5614 7.3573 23.8676 7.05841L25.9519 5.02325C26.1063 4.8725 26.3136 4.78809 26.5293 4.78809C26.7391 4.78809 26.941 4.86786 27.0942 5.01123L29.2932 7.07001C29.6056 7.36243 30.0927 7.3573 30.3988 7.05841L32.4832 5.02325C32.6376 4.8725 32.8448 4.78809 33.0605 4.78809C33.2704 4.78809 33.4723 4.86786 33.6255 5.01123L35.8245 7.07001C36.1368 7.36243 36.6239 7.3573 36.9301 7.05841L39.0144 5.02325C39.1688 4.8725 39.3761 4.78809 39.5918 4.78809C39.8016 4.78809 40.0035 4.86786 40.1567 5.01123L42.3557 7.07001C42.6681 7.36243 43.1552 7.3573 43.4613 7.05841L45.5457 5.02325C45.7001 4.8725 45.9073 4.78809 46.123 4.78809C46.3329 4.78809 46.5348 4.86786 46.688 5.01123L48.887 7.07001C49.1993 7.36243 49.6864 7.3573 49.9926 7.05841L51.7004 5.39088Z"
      fill="url(#paint3_linear_9837_4132)"
    />
    <path
      d="M52.6452 7.32918C52.5132 6.50195 52.5927 6.02435 52.2464 5.74009C52.0812 5.60444 51.8454 5.64485 51.6925 5.7942L49.9846 7.46173C49.6784 7.76062 49.1914 7.76575 48.879 7.47333L46.68 5.41455C46.5268 5.27118 46.3249 5.19141 46.1151 5.19141C45.8994 5.19141 45.6921 5.27582 45.5377 5.42657L43.4533 7.46173C43.1472 7.76062 42.6601 7.76575 42.3478 7.47333L40.1488 5.41455C39.9956 5.27118 39.7937 5.19141 39.5838 5.19141C39.3681 5.19141 39.1609 5.27582 39.0064 5.42657L36.9221 7.46173C36.6159 7.76062 36.1289 7.76575 35.8165 7.47333L33.6175 5.41455C33.4643 5.27118 33.2624 5.19141 33.0526 5.19141C32.8369 5.19141 32.6296 5.27582 32.4752 5.42657L30.3908 7.46173C30.0847 7.76062 29.5976 7.76575 29.2853 7.47333L27.0863 5.41455C26.9331 5.27118 26.7312 5.19141 26.5213 5.19141C26.3056 5.19141 26.0984 5.27582 25.9439 5.42657L23.8596 7.46173C23.5534 7.76062 23.0664 7.76575 22.754 7.47333L20.555 5.41455C20.4018 5.27118 20.1999 5.19141 19.9901 5.19141C19.7744 5.19141 19.5671 5.27582 19.4127 5.42657L17.3283 7.46173C17.0222 7.76062 16.5351 7.76575 16.2228 7.47333L14.3577 5.72728C14.2134 5.59223 14.0276 5.61348 13.8661 5.72728C13.5504 5.94967 13.4188 6.24865 13.3169 6.88306"
      stroke="url(#paint4_linear_9837_4132)"
      stroke-opacity="0.7"
      stroke-width="0.2"
    />
    <path
      d="M37.276 52.5693C37.276 51.4648 36.3806 50.5693 35.276 50.5693H9.08125C7.98358 50.5693 7.09375 51.4592 7.09375 52.5568C7.09375 56.9475 10.6531 60.5068 15.0438 60.5068H43.3427C38.5519 60.0813 37.3251 55.4106 37.276 52.7452V52.5693Z"
      fill="url(#paint5_linear_9837_4132)"
    />
    <path
      d="M37.276 52.5693C37.276 51.4648 36.3806 50.5693 35.276 50.5693H9.08125C7.98358 50.5693 7.09375 51.4592 7.09375 52.5568C7.09375 56.9475 10.6531 60.5068 15.0438 60.5068H43.3427C38.5519 60.0813 37.3251 55.4106 37.276 52.7452V52.5693Z"
      fill="url(#paint6_linear_9837_4132)"
    />
    <path
      d="M37.276 52.5693C37.276 51.4648 36.3806 50.5693 35.276 50.5693H9.08125C7.98358 50.5693 7.09375 51.4592 7.09375 52.5568C7.09375 56.9475 10.6531 60.5068 15.0438 60.5068H43.3427C38.5519 60.0813 37.3251 55.4106 37.276 52.7452V52.5693Z"
      fill="url(#paint7_radial_9837_4132)"
    />
    <path
      d="M19.0938 14.6787C19.0938 13.6 19.9682 12.7256 21.0469 12.7256H45.0469C46.1256 12.7256 47 13.6 47 14.6787C47 15.7574 46.1256 16.6318 45.0469 16.6318H21.0469C19.9682 16.6318 19.0938 15.7574 19.0938 14.6787Z"
      fill="#97939D"
    />
    <path
      d="M19.0938 21.6943C19.0938 21.1248 19.5555 20.6631 20.125 20.6631H35.9375C36.507 20.6631 36.9688 21.1248 36.9688 21.6943C36.9688 22.2639 36.507 22.7256 35.9375 22.7256H20.125C19.5555 22.7256 19.0938 22.2639 19.0938 21.6943Z"
      fill="#97939D"
    />
    <path
      d="M19.0938 27.6318C19.0938 27.0623 19.5555 26.6006 20.125 26.6006H35.9375C36.507 26.6006 36.9688 27.0623 36.9688 27.6318C36.9688 28.2014 36.507 28.6631 35.9375 28.6631H20.125C19.5555 28.6631 19.0938 28.2014 19.0938 27.6318Z"
      fill="#97939D"
    />
    <path
      d="M19.0938 33.6787C19.0938 33.1092 19.5555 32.6475 20.125 32.6475H35.9375C36.507 32.6475 36.9688 33.1092 36.9688 33.6787C36.9688 34.2483 36.507 34.71 35.9375 34.71H20.125C19.5555 34.71 19.0938 34.2483 19.0938 33.6787Z"
      fill="#97939D"
    />
    <path
      d="M19.0938 39.7256C19.0938 39.156 19.5555 38.6943 20.125 38.6943H35.9375C36.507 38.6943 36.9688 39.156 36.9688 39.7256C36.9688 40.2951 36.507 40.7568 35.9375 40.7568H20.125C19.5555 40.7568 19.0938 40.2951 19.0938 39.7256Z"
      fill="#97939D"
    />
    <path
      d="M19.0938 45.7725C19.0938 45.2029 19.5555 44.7412 20.125 44.7412H35.9375C36.507 44.7412 36.9688 45.2029 36.9688 45.7725C36.9688 46.342 36.507 46.8037 35.9375 46.8037H20.125C19.5555 46.8037 19.0938 46.342 19.0938 45.7725Z"
      fill="#97929F"
    />
    <path
      d="M39.0312 27.6318C39.0312 27.0623 39.493 26.6006 40.0625 26.6006H45.9688C46.5383 26.6006 47 27.0623 47 27.6318C47 28.2014 46.5383 28.6631 45.9688 28.6631H40.0625C39.493 28.6631 39.0312 28.2014 39.0312 27.6318Z"
      fill="#97939D"
    />
    <path
      d="M39.0312 21.6943C39.0312 21.1248 39.493 20.6631 40.0625 20.6631H45.9688C46.5383 20.6631 47 21.1248 47 21.6943C47 22.2639 46.5383 22.7256 45.9688 22.7256H40.0625C39.493 22.7256 39.0312 22.2639 39.0312 21.6943Z"
      fill="#97939D"
    />
    <path
      d="M39.0312 33.6787C39.0312 33.1092 39.493 32.6475 40.0625 32.6475H45.9688C46.5383 32.6475 47 33.1092 47 33.6787C47 34.2483 46.5383 34.71 45.9688 34.71H40.0625C39.493 34.71 39.0312 34.2483 39.0312 33.6787Z"
      fill="#97939D"
    />
    <path
      d="M39.0312 39.7256C39.0312 39.156 39.493 38.6943 40.0625 38.6943H45.9688C46.5383 38.6943 47 39.156 47 39.7256C47 40.2951 46.5383 40.7568 45.9688 40.7568H40.0625C39.493 40.7568 39.0312 40.2951 39.0312 39.7256Z"
      fill="#97939D"
    />
    <path
      d="M39.0312 45.7725C39.0312 45.2029 39.493 44.7412 40.0625 44.7412H45.9688C46.5383 44.7412 47 45.2029 47 45.7725C47 46.342 46.5383 46.8037 45.9688 46.8037H40.0625C39.493 46.8037 39.0312 46.342 39.0312 45.7725Z"
      fill="#9893A0"
    />
    <path
      d="M52.7109 51.7715C52.7109 56.8002 49.2023 60.2715 44.2109 60.2715H42.4756"
      stroke="url(#paint8_linear_9837_4132)"
      stroke-width="0.2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_9837_4132"
        x1="17"
        y1="34.0068"
        x2="52.9375"
        y2="34.0068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DFD8E8" />
        <stop
          offset="1"
          stop-color="#E0DBEA"
        />
      </linearGradient>
      <radialGradient
        id="paint1_radial_9837_4132"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.5562 60.5068) rotate(-60.1007) scale(10.6702 16.7308)"
      >
        <stop stop-color="#F9F3FE" />
        <stop
          offset="1"
          stop-color="#F9F3FE"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint2_linear_9837_4132"
        x1="52.9375"
        y1="45.058"
        x2="51.9452"
        y2="45.058"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCF9FF" />
        <stop
          offset="1"
          stop-color="#FCF9FF"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_9837_4132"
        x1="13.0937"
        y1="45.058"
        x2="14.0395"
        y2="45.058"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BBB8C3" />
        <stop
          offset="1"
          stop-color="#C7C1CF"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_9837_4132"
        x1="52.6453"
        y1="5.19141"
        x2="13.3169"
        y2="5.19141"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFFFF" />
        <stop
          offset="0.0209492"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.0838254"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.0899253"
          stop-color="#FFFFFF"
        />
        <stop
          offset="0.15984"
          stop-color="#FFFFFF"
        />
        <stop
          offset="0.17204"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.24477"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.251016"
          stop-color="#FFFFFF"
        />
        <stop
          offset="0.320315"
          stop-color="#FFFFFF"
        />
        <stop
          offset="0.340022"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.400552"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.410365"
          stop-color="#FFFFFF"
        />
        <stop
          offset="0.494397"
          stop-color="#FFFFFF"
        />
        <stop
          offset="0.504525"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.575104"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.581095"
          stop-color="#FFFFFF"
        />
        <stop
          offset="0.65628"
          stop-color="#FFFFFF"
        />
        <stop
          offset="0.66801"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.743548"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.748721"
          stop-color="#FFFFFF"
        />
        <stop
          offset="0.824257"
          stop-color="#FFFFFF"
        />
        <stop
          offset="0.83787"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.909661"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
        <stop
          offset="0.912477"
          stop-color="#FFFFFF"
          stop-opacity="0.898358"
        />
        <stop
          offset="0.97723"
          stop-color="#FFFFFF"
          stop-opacity="0.823752"
        />
        <stop
          offset="0.985676"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_9837_4132"
        x1="25.2182"
        y1="50.5693"
        x2="25.2182"
        y2="60.5068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DCD4E8" />
        <stop
          offset="1"
          stop-color="#C9BADD"
        />
      </linearGradient>
      <linearGradient
        id="paint6_linear_9837_4132"
        x1="30.5"
        y1="60.5068"
        x2="30.5"
        y2="55.5381"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A58BC5" />
        <stop
          offset="1"
          stop-color="#C7B7DD"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint7_radial_9837_4132"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(44.4576 54.1073) rotate(160.811) scale(8.01336 7.65091)"
      >
        <stop
          offset="0.851516"
          stop-color="#FFFFFF"
        />
        <stop
          offset="0.938869"
          stop-color="#FFFFFF"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint8_linear_9837_4132"
        x1="42.5563"
        y1="60.2715"
        x2="52.3709"
        y2="52.4513"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.0284376"
          stop-color="#F8F5FC"
          stop-opacity="0"
        />
        <stop
          offset="0.214791"
          stop-color="#F8F5FC"
        />
        <stop
          offset="1"
          stop-color="#F8F5FC"
          stop-opacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
